module.exports = "/_next/static/pages/practice/50496b1b1f100da0926c6e23de86d7fa.jpg";